import { on } from "@ngrx/store";
import { SuperUserState } from "../super-user.state";
import { DeliveryTermsActions } from "./delivery-terms.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update superUser state within PagesStore
// **************************************************************************

function withSuperUser(state: PagesStore, updater: (superUser: SuperUserState) => SuperUserState): PagesStore {
    return { ...state, superUser: updater(state.superUser) };
}

// **************************************************************************
// DELIVERY TERMS REDUCER (array format for PagesStore)
// **************************************************************************

const load = on(DeliveryTermsActions.load, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, loading: true, error: null },
})));

const loadSuccess = on(DeliveryTermsActions.loadSuccess, (state: PagesStore, { deliveryTerms }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, deliveryTerms, loaded: true, loading: false, error: null },
})));

const invalidate = on(DeliveryTermsActions.invalidate, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, loaded: false },
})));

const loadFailure = on(DeliveryTermsActions.loadFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, loading: false, error },
})));

const createDeliveryTerm = on(DeliveryTermsActions.createDeliveryTerm, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, error: null },
})));

const createDeliveryTermSuccess = on(DeliveryTermsActions.createDeliveryTermSuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, error: null },
})));

const createDeliveryTermFailure = on(DeliveryTermsActions.createDeliveryTermFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, error },
})));

const updateDeliveryTerm = on(DeliveryTermsActions.updateDeliveryTerm, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, error: null },
})));

const updateDeliveryTermSuccess = on(DeliveryTermsActions.updateDeliveryTermSuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, error: null },
})));

const updateDeliveryTermFailure = on(DeliveryTermsActions.updateDeliveryTermFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, error },
})));

const deleteDeliveryTerm = on(DeliveryTermsActions.deleteDeliveryTerm, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, error: null },
})));

const deleteDeliveryTermSuccess = on(DeliveryTermsActions.deleteDeliveryTermSuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, error: null },
})));

const deleteDeliveryTermFailure = on(DeliveryTermsActions.deleteDeliveryTermFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    deliveryTerms: { ...superUserState.deliveryTerms, error },
})));

export const deliveryTermsReducer = [
    invalidate,
    load,
    loadSuccess,
    loadFailure,
    createDeliveryTerm,
    createDeliveryTermSuccess,
    createDeliveryTermFailure,
    updateDeliveryTerm,
    updateDeliveryTermSuccess,
    updateDeliveryTermFailure,
    deleteDeliveryTerm,
    deleteDeliveryTermSuccess,
    deleteDeliveryTermFailure,
];
